import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  /* border: 5px solid red; */
  column-gap: 60px;
  row-gap: 48px;
  grid-template-columns: repeat(3, 1fr);
  width: 90%;
  max-width: 950px;
  margin: 0 auto;

  ${({ theme }) => theme.old.breakpoints.isTab} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    grid-template-columns: 1fr;
    row-gap: 24px;
  }
`